import { Component, Inject, OnInit } from '@angular/core';
import { Partner } from '../../../shared/interface/partner';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Note } from "../../../shared/interface/note";
import { Ofwca } from "../../../shared/interface/ofwca";

export interface NoteAddDialogData {
  partner?: Partner;
  ofwca?: Ofwca;
  note?: Note;
}

@Component({
  selector: 'app-note-add-dialog',
  templateUrl: './note-add-dialog.component.html',
  styleUrls: ['./note-add-dialog.component.scss']
})
export class NoteAddDialogComponent implements OnInit {
  partnerObject?: Partner = null;
  noteObject?: Note = null;
  ofwcaObject?: Ofwca = null;

  constructor(
    public dialogRef: MatDialogRef<NoteAddDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: NoteAddDialogData
  ) {
    this.partnerObject = data.partner;
    this.noteObject = data.note;
    this.ofwcaObject = data.ofwca;
  }

  ngOnInit(): void {
  }

  closeDialog(e): void {
    this.dialogRef.close(e);
  }
}
